import manage from 'top20common/distribution/services/manage';

export default {
  fetchUsersListAction(context, params = {}) {
    manage.getUsers(params).then(response => {
      context.commit('setUsersListState', response.data.results);
    });
  },
  changeAccountSettingsManage(context, data) {
    manage.setAccountSettingsManage(data).then(response => {
      console.log('sett account settings', response.data);
    })
  }
};
